import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Button } from 'gdpp-components/dist/cjs/components/atoms'
import { dispatchFundCompareEvent } from 'utils/tracking'

import './style.scss'

const StickyContainer = ({
  isOpen,
  collapsable,
  collapseContent,
  containerHeader,
  hasActions,
  confirmLabel,
  clearLabel,
  onConfirm,
  // cancelLabel,
  onCancel,
  hasCloseIcon,
  disableConfirmBtn,
  // disableCancelBtn,
  extraClasses,
  children,
  confirmUrl
}) => {
  const [isExpanded, setExpandedStatus] = useState(true)
  const [openStatus, setOpenStatus] = useState()

  const handleExpandedStatus = () => {
    setExpandedStatus(!isExpanded)
  }

  const closeContainer = () => {
    setOpenStatus(false)
  }

  const handleConfirm = () => {
    setOpenStatus(false)
    onConfirm()
    if (confirmUrl) {
      dispatchFundCompareEvent('compare - compare selected funds', confirmUrl.substring(confirmUrl.indexOf('scIds=') + 6))
    }
  }

  const handleCancel = () => {
    setOpenStatus(false)
    onCancel()
  }

  useEffect(() => {
    setOpenStatus(isOpen)
  }, [isOpen])

  return (
    <React.Fragment>
      {openStatus && (
        <div className={classnames('fil-sticky-container', extraClasses)}>
          <div className="fil-sticky-container-header align-justify">
            <div>
              {containerHeader && <span className="fil-sticky-container-header-content">{containerHeader}</span>}
              {(!collapsable || isExpanded) && (
                <Button
                  extraClasses="fil-sticky-container-header-clear"
                  kind="textlink"
                  icon="bin-1"
                  iconPosition="left"
                  iconSize="16"
                  size="small"
                  label={clearLabel}
                  onClick={handleCancel}
                />
              )}
            </div>
            {collapsable && (
              <span className="fil-sticky-container-header-collapse" onClick={handleExpandedStatus}>
                <fil-icon icon={`custom-chevron-${isExpanded ? 'down' : 'up'}`} size="16" />
                <span className="fil-sticky-container-header-collapse-content show-for-large">
                  {isExpanded ? collapseContent.close : collapseContent.open}
                </span>
              </span>
            )}
            {hasCloseIcon && (
              <span className="fil-sticky-container-header-close" onClick={closeContainer}>
                <fil-icon icon="close" size="16" />
              </span>
            )}
          </div>
          {(!collapsable || isExpanded) && <div className="fil-sticky-container-body">{children}</div>}
          {hasActions && (!collapsable || isExpanded) && (
            <div className="fil-sticky-container-footer">
              <Button
                disabled={disableConfirmBtn}
                extraClasses="fil-sticky-container-footer-confirm"
                onClick={handleConfirm}
                label={confirmLabel}
                {...(confirmUrl ? { url: confirmUrl, target: '_self' } : {})}
              />
              {/* <Button disabled={disableCancelBtn} onClick={handleCancel} size="small" kind="tertiary" label={cancelLabel} /> */}
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  )
}

StickyContainer.propTypes = {
  children: PropTypes.any.isRequired,
  isOpen: PropTypes.bool,
  extraClasses: PropTypes.string,
  collapsable: PropTypes.bool,
  collapseContent: PropTypes.object,
  containerHeader: PropTypes.any,
  hasActions: PropTypes.bool,
  confirmLabel: PropTypes.string,
  clearLabel: PropTypes.string,
  confirmUrl: PropTypes.string,
  onConfirm: PropTypes.func,
  cancelLabel: PropTypes.string,
  onCancel: PropTypes.func,
  hasCloseIcon: PropTypes.bool,
  disableConfirmBtn: PropTypes.bool,
  disableCancelBtn: PropTypes.bool
}

StickyContainer.defaultProps = {
  isOpen: false,
  extraClasses: '',
  collapsable: false,
  collapseContent: {
    open: 'open',
    close: 'close'
  },
  containerHeader: '',
  hasActions: true,
  confirmLabel: 'Confirm',
  clearLabel: 'Clear',
  confirmUrl: '',
  onConfirm: () => {},
  cancelLabel: 'Cancel',
  onCancel: () => {},
  hasCloseIcon: true,
  disableConfirmBtn: false,
  disableCancelBtn: false
}

export default StickyContainer
